import type { ComponentType } from 'react';
import UltimatePickerImpl from './UltimatePicker';

interface UltimatePickerProps {
  value?: string;
  onChange?: (v: string) => void;
  linkValue?: string;
  onLinkChange?: (v: string) => void;
  streetViewValue?: string;
  onStreetViewChange?: (v: string) => void;
  thumbnailValue?: string;
  onThumbnailChange?: (v: string) => void;
  googleApiKey?: string;
}

const UltimatePicker = UltimatePickerImpl as unknown as ComponentType<UltimatePickerProps>;
export default UltimatePicker;
